import React from "react";
import QRCode from "qrcode.react";
import { useImgs } from "../../../../hooks/ImgsHooks";
import classes from "./CodeQrA.module.css";

const CodeQrA = ({ code_qr_url, id_comercio }) => {
  const {
    imgs: { AsignacionQrFondoCodeQr },
  } = useImgs();

  return (
    <div className={classes.ContainerFather}>
      <div className={classes.ContainerCode}>
        <img
          className={classes.ImgFondo}
          width="800"
          src={AsignacionQrFondoCodeQr}
          alt="Fondo Code Qr"
        />

        <div className={classes.ContainerRectangle}>
          <QRCode value={code_qr_url} size={300}></QRCode>
        </div>
        <div className={classes.ContainerId}>{`ID: ${id_comercio}`}</div>
      </div>
    </div>
  );
};

export default CodeQrA;
